<template>
  <div class="separator"/>
</template>

<script>

export default {
  name: 'Separator',
};
</script>

<style lang="scss" scoped>
  @import '../scss/riseup-colors';

  .separator {
    height: 1px;
    width: 100%;
    background: $riseup_gray_0;
  }

</style>
